// extracted by mini-css-extract-plugin
module.exports = {"objectFitCover":"style_objectFitCover__MisAN","objectFitContain":"style_objectFitContain__ne_jo"};